import { reducerWrapper } from '../../support/utils';

import { UPSELL } from '../../actions/EmailOnboarding/Upsell';

var INIT_STATE = {
  loading: false,
  error: null,
};

function Handler(state, action) {
  switch (action.type) {
    case UPSELL.response:
      return Object.assign({}, state, {
        loading: false,
        error: null,
        ...action.data,
      });

    default:
      return state;
  }
}

const Upsell = reducerWrapper(INIT_STATE, Handler, {
  request: [UPSELL],
  error: [UPSELL],
  resetOn: ['APP_CHANGE'],
});

export default Upsell;
